var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"center-center"},[_c('div',[_c('p',[_vm._v("Single-Sign on failed. Please contact support for access.")]),_c('div',[_c('PrimeButton',{attrs:{"to":"/login","block":""}},[_vm._v("Return to Login")])],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }